// АВТОМАТИЧЕСКИ СГЕНЕРИРОВАННЫЙ ФАЙЛ
// Команда для обновления: nx run uikit-icons:generate

export const ICON_NAMES = [
  "ai-analyze"
] as const;

export type IconName = typeof ICON_NAMES[number];
